import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getCoreLevel } from '../../../../publicSession/selectors';
import { getMaxPriceForCoreLevel, DOLLAR_PRICE_MIN_VALUE } from '../../../../utils/profits';
import { formatDollars } from '../../../../utils/formatting';
import * as yup from 'yup';
const useValidation = ()=>{
    const { t } = useTranslation();
    const coreLevel = useSelector(getCoreLevel);
    const priceMaxValue = getMaxPriceForCoreLevel(coreLevel);
    const validationSchema = useMemo(()=>yup.object({
            price: yup.number().typeError(t('tierPopup.validation.error.price.required')).required(t('tierPopup.validation.error.price.required')).min(DOLLAR_PRICE_MIN_VALUE, t('common.dollarPriceInput.validation.error.minValue', {
                min: formatDollars(DOLLAR_PRICE_MIN_VALUE)
            })).max(priceMaxValue, t('common.dollarPriceInput.validation.error.maxValue', {
                max: formatDollars(priceMaxValue)
            }))
        }), [
        t,
        priceMaxValue
    ]);
    return validationSchema;
};
export default useValidation;

//# sourceMappingURL=useValidation.js.map